import { createContext, useContext, type FC, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type EntitiesStore } from 'entities/EntitiesExport/store/entitiesExportStore'

export const EntitiesContext = createContext<EntitiesStore | null>(null)

export const useEntitiesContext = () => {
  const context = useContext(EntitiesContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with EntitiesContext')

  return context
}

type IProviderEntitiesProps = {
  entities: EntitiesStore
  children: ReactNode
}

export const ProviderEntities: FC<IProviderEntitiesProps> = observer(({ entities, children }) => {
  return <EntitiesContext.Provider value={entities}>{children}</EntitiesContext.Provider>
})
